import script from "./AuftragPensus.vue?vue&type=script&setup=true&lang=js"
export * from "./AuftragPensus.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__